import {
  GET_GROUP_TRANSACTION_ERROR,
  GET_GROUP_TRANSACTION_START,
  GET_GROUP_TRANSACTION_SUCCESS,
} from 'constants/action-types/groups/getGroupTransactions';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_GROUP_TRANSACTION_START:
      return {
        ...state,
        groupTransactions: {
          ...state.groupTransactions,
          loading: true,
          error: null,
          data: [],
          meta: {},
          monthlyBalances: [],
          group: {},
        },
      };
    case GET_GROUP_TRANSACTION_SUCCESS:
      return {
        ...state,
        groupTransactions: {
          ...state.groupTransactions,
          loading: false,
          meta: payload.meta,
          data: payload.data,
          monthlyBalances: payload?.meta?.monthly_balances || [],
          group: payload?.meta?.group || {},
        },
      };
    case GET_GROUP_TRANSACTION_ERROR:
      return {
        ...state,
        groupTransactions: {
          ...state.groupTransactions,
          error: payload,
          loading: false,
        },
      };
    default:
      return null;
  }
};
